import React, { useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Dialog,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Actions, useDispatchProvider, useStateDialogProduct } from '../utils/StateProvider';
import FormProduct from '../forms/FormProduct';

const DialogProduct = () => {
  const portalRef = useRef(null);
  const stateDialogProduct = useStateDialogProduct();
  const dispatch = useDispatchProvider();
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    dispatch && dispatch({ type: Actions.DialogProduct, payload: false });
  };

  return (
    <Dialog
      open={stateDialogProduct}
      onClose={handleDialogClose}
      maxWidth={'sm'}
      fullWidth={true}
      fullScreen={useMediaQuery((theme) => theme.breakpoints.down('md'))}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDialogClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Product Details
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <FormProduct portalRef={portalRef} />
      </DialogContent>
      <DialogActions
        sx={{ paddingX: 3, paddingY: 2 }}
        ref={portalRef}
      ></DialogActions>
    </Dialog>
  );
};

export default DialogProduct;
